import { defineNuxtPlugin } from '#app'
import posthog, { type ConfigDefaults } from 'posthog-js'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()
  const posthogClient = posthog.init(runtimeConfig.public.posthog.publicKey, {
    api_host: runtimeConfig.public.posthog.host,
    defaults: runtimeConfig.public.posthog.defaults as ConfigDefaults,
    person_profiles: 'identified_only',
  })

  return {
    provide: {
      posthog: posthogClient,
    },
  }
})
